import { Injectable } from '@angular/core';
import { ContractNetworkingUserRegisterInput, ContractNetworkingUserRegisterOutput } from '../4.2.contract/contract.user.register/contract.networking.user.register';
import { ModelUserData } from '../4.3.model/model.user.data';
import { HttpClient } from '@angular/common/http';
import { ApiEndpoint } from '../4.1.common/api.endpoint';
import { UtilCryptography } from 'src/app/5.transversal/5.2.utils/util.cryptography/util.cryptography';
import { ModelDefaultResponse } from '../4.3.model/model.default.response';

@Injectable({
    providedIn: 'root'
})
export class NetworkingUserRegister implements ContractNetworkingUserRegisterInput {

    constructor(
        private httpClient: HttpClient,
        private apiEndpoint: ApiEndpoint,
        private cryptography: UtilCryptography
    ){}
    
    networkingOutput?: ContractNetworkingUserRegisterOutput;

    registerUser(data: ModelUserData): void {
        console.log(data);
        let encryptedData = this.cryptography.encrypt(JSON.stringify(data));
        this.httpClient.post<any>(
            this.apiEndpoint.userRegister(), 
            `{"data":"${encryptedData}"}`
        ).subscribe(
            response => {
                if(response.status){
                    //console.log("response successful: ", response)
                    this.networkingOutput?.userRegisterSuccessfulOutput();
                }else{
                    //console.log("response failure: ", response)
                    this.networkingOutput?.userRegisterFailureOutput();
                }
            },
            _ => {
                //console.log("response _: ", _)
                this.networkingOutput?.userRegisterFailureOutput();
            }
        )
    }

}